/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_VisibilityInputs */

const en_views_visibility = /** @type {(inputs: Views_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible to`)
};

const de_views_visibility = /** @type {(inputs: Views_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbar für`)
};

/**
* | output |
* | --- |
* | "Visible to" |
*
* @param {Views_VisibilityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_visibility = /** @type {((inputs?: Views_VisibilityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_VisibilityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_visibility(inputs)
	return en_views_visibility(inputs)
});